module.exports = __webpack_public_path__ + "static/img/banner0.f5de57d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/home/banner0.jpg
// module id = 0v/x
// module chunks = 0